////////////////
// Analytics //
//////////////

// const GameAnalytics = {
//     "reportStageStart": function() {},
//     "reportStageSuccess": function() {},
//     "reportStageFailure": function() {},
//     "reportError": function() {},
// }
// if(window.environment != "node") {
//     console.log("TODO: ACTUALLY INSTANTIATE ANALYTICS HERE")
// }

import GameAnalytics from "not-game-analytics"

GameAnalytics.isReporting = true
GameAnalytics.BUILD_VERSION = "v0.22.5"

import app from "@fae/source/data/app.js"
import games from "@fae/source/data/games"
const game = games[app.defaultGameSlug]
GameAnalytics.GAME_KEY = game?.analytics?.gameKey
GameAnalytics.SECRET_KEY = game?.analytics?.secretKey

console.log("%cInitializing analytics for " + game?.key, "background-color: black; color: white;")

window.addEventListener("error", (error) => {
    GameAnalytics.reportError(error)
})

export default GameAnalytics
